import { Component, OnInit, ChangeDetectorRef, Input, OnDestroy, ViewRef, ChangeDetectionStrategy } from '@angular/core';
import { AppStateService } from "src/app/core-module/services/app-state.service";
import { FieldType } from "@ngx-formly/core";
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';

import { AloAocStateService } from "../../../core-module/services/state/alo-aoc-state.service";
import { FeatureDataStateService } from "../../../core-module/services/state/feature-data-state.service";
import { FeatureDefaultsStateService } from "../../../core-module/services/state/feature-defaults-state.service";
@Component({
  standalone: false,
  selector: "app-apm-dim",
  templateUrl: "./apm-dim.component.html",
  styleUrls: ["./apm-dim.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApmDimComponent extends FieldType implements OnInit, OnDestroy {
  @Input() field;
  column: LegacyAny;
  properties: LegacyAny;
  ngModelval: LegacyAny = {};
  inputError: LegacyAny = [];
  quickConfigvalue: boolean;
  quickConfigCustomCSS: string;
  setQuickConfig: string;
  ampdimDefaultColor;
  ampDimCreateFile: boolean;
  mtpEnabledval: LegacyAny;
  selectedInterface = [];
  showAmpDimEnabled = false;
  isEnableFeature = false;
  ampDimDisabled = false;

  showFieldsAsPerAllOf: LegacyAny;

  VmainsStop: LegacyAny;
  VmainsStopMin: LegacyAny;
  VmainsStopMax: LegacyAny;
  VmainsStopValue: LegacyAny;
  VmainsStopOption: { floor: LegacyAny; ceil: LegacyAny; minLimit: LegacyAny };
  VmainsStart: LegacyAny;
  VmainsStartMin: LegacyAny;
  VmainsStartValue: LegacyAny;
  VmainsStartOption: { floor: LegacyAny; ceil: LegacyAny; minLimit: LegacyAny };
  StopDimLevel: LegacyAny;
  StopDimLevelMin: LegacyAny;
  StopDimLevelMax: LegacyAny;
  StopDimLevelValue: LegacyAny;
  StopDimLevelOption: { floor: LegacyAny; ceil: LegacyAny; minLimit: LegacyAny };
  StartDimLevel: LegacyAny;
  StartDimLevelMin: LegacyAny;
  StartDimLevelValue: LegacyAny;
  StartDimLevelOption: { floor: LegacyAny; ceil: LegacyAny; minLimit: LegacyAny };
  mtpDefaultColor: boolean;
  DimLevel: LegacyAny;
  mtpPhilipsLedLightEnginesSelected: boolean;
  DimLevelMin: LegacyAny;
  DimLevelMax: LegacyAny;
  VmainsStartMax: LegacyAny;
  StartDimLevelMax: LegacyAny;

  VmainsStopDisplayValue: LegacyAny;
  StopDimLevelDisplayValue: LegacyAny;
  VmainsStartDisplayValue: LegacyAny;
  StartDimLevelDisplayValue: LegacyAny;

  private vmainsStopInputSubject = new Subject<string>();
  private stopDimLevelInputSubject = new Subject<string>();
  private vmainsStartInputSubject = new Subject<string>();
  private startDimLevelInputSubject = new Subject<string>();
  public service: LegacyAny;

  constructor(
    private ref: ChangeDetectorRef, private appState: AppStateService,
    private featureData: FeatureDataStateService,
    private featureDefaults: FeatureDefaultsStateService,
    private aloAoc: AloAocStateService
  ) {
    super();
    this.service = {
      getAmpDimGraphdata: this.featureData.getAmpDimGraphdata,
      getAmpDimDefaultValue: this.featureDefaults.getAmpDimDefaultValue,
      getquickConfig: this.aloAoc.getquickConfig,
      sendAmpDimdata: (data: LegacyAny) => this.featureData.sendAmpDimdata(data),
      setAmpDimDefaultColor: (isDefault: boolean) =>
        this.featureDefaults.setAmpDimDefaultColor(isDefault),
      ampdimInputError: (hasError: boolean) => this.featureData.ampdimInputError(hasError)
    };
  }
  sliderEvent(option?) {}

  ngOnInit() {
    this.service.getAmpDimGraphdata.subscribe((responseGraph) => {
      for (let index = 0; index < responseGraph.length; index++) {
        const element = responseGraph[index];
        if (index === 0) {
          this.StopDimLevelValue = Math.round(element.dyanYOutput);
        }
        if (index === 1) {
          this.VmainsStopValue = Math.round(element.dyanXTime);
        }
        if (index === 2) {
          this.StartDimLevelValue = Math.round(element.dyanYOutput);
          this.VmainsStartValue = Math.round(element.dyanXTime);
        }
      }
      this.ngModelval["StopDimLevelValue"] = this.StopDimLevelValue;
      this.ngModelval["VmainsStopValue"] = this.VmainsStopValue;
      this.ngModelval["StartDimLevelValue"] = this.StartDimLevelValue;
      this.ngModelval["VmainsStartValue"] = this.VmainsStartValue;

      this.StopDimLevelDisplayValue = this.StopDimLevelValue;
      this.VmainsStopDisplayValue = this.VmainsStopValue;
      this.StartDimLevelDisplayValue = this.StartDimLevelValue;
      this.VmainsStartDisplayValue = this.VmainsStartValue;

      this.checkDefaults();
      this.checkInvalidValues();
      this.ref.markForCheck();
    });
    this.service.getAmpDimDefaultValue.subscribe((response) => {
      if (response == "valid") {
        this.ampdimDefaultColor = true;

        this.resetDefaultAmpDimValues();
        this.ref.markForCheck();
      }
    });

    // Guard: If schema not loaded, initialize with safe defaults and return
    if (!this.field || !this.field.properties || !this.field.requiredProperties) {
      this.VmainsStopOption = { floor: 0, ceil: 100, minLimit: 0 };
      this.VmainsStartOption = { floor: 0, ceil: 100, minLimit: 0 };
      this.StopDimLevelOption = { floor: 0, ceil: 100, minLimit: 0 };
      this.StartDimLevelOption = { floor: 0, ceil: 100, minLimit: 0 };
      return;
    }

    this.column = this.field.requiredProperties;
    this.properties = this.field.properties;
    const type = this.column[0];
    this.service.ampdimInputError(false);

    this.VmainsStop = this.properties.VmainsStop;
    this.VmainsStopMin = this.VmainsStop.minimum;
    this.VmainsStopMax = this.VmainsStop.maximum;
    this.ngModelval["VmainsStopValue"] = this.VmainsStopValue =
      this.VmainsStop.default;
    this.VmainsStopDisplayValue = this.VmainsStop.default;
    this.ngModelval["VmainsStopMax"] = this.VmainsStop.maximum;
    this.VmainsStopOption = {
      floor: this.VmainsStopMin,
      ceil: this.VmainsStopMax,
      minLimit: this.VmainsStartMin,
    };
    this.VmainsStart = this.properties.VmainsStart;
    this.VmainsStartMin = this.VmainsStart.minimum;
    this.VmainsStartMax = this.VmainsStart.maximum;
    this.ngModelval["VmainsStartValue"] = this.VmainsStartValue =
      this.VmainsStart.default;
    this.VmainsStartDisplayValue = this.VmainsStart.default;
    this.ngModelval["VmainsStartMax"] = this.VmainsStart.maximum;
    this.VmainsStartOption = {
      floor: this.VmainsStartMin,
      ceil: this.VmainsStartMax,
      minLimit: this.VmainsStopMin,
    };

    this.StopDimLevel = this.properties.StopDimLevel;
    this.StopDimLevelMin = this.StopDimLevel.minimum;
    this.StopDimLevelMax = this.StopDimLevel.maximum;
    this.ngModelval["StopDimLevelValue"] = this.StopDimLevelValue =
      this.StopDimLevel.default;
    this.StopDimLevelDisplayValue = this.StopDimLevel.default;
    this.ngModelval["StopDimLevelMax"] = this.StopDimLevel.maximum;
    this.StopDimLevelOption = {
      floor: this.StopDimLevelMin,
      ceil: this.StopDimLevelMax,
      minLimit: this.StartDimLevelMin,
    };
    this.StartDimLevel = this.properties.StartDimLevel;
    this.StartDimLevelMin = this.StartDimLevel.minimum;
    this.StartDimLevelMax = this.StartDimLevel.maximum;
    this.ngModelval["StartDimLevelValue"] = this.StartDimLevelValue =
      this.StartDimLevel.default;
    this.StartDimLevelDisplayValue = this.StartDimLevel.default;
    this.ngModelval["StartDimLevelMax"] = this.StartDimLevel.maximum;
    this.StartDimLevelOption = {
      floor: this.StartDimLevelMin,
      ceil: this.StartDimLevelMax,
      minLimit: this.StopDimLevelMin,
    };

    // Check if AmpDimEnabled exists in required properties
    this.showAmpDimEnabled = this.column.includes('AmpDimEnabled');
    if (this.showAmpDimEnabled) {
      this.ngModelval["AmpDimEnabledVal"] = this.isEnableFeature = this.properties.AmpDimEnabled?.default ?? false;
      this.ampDimDisabled = !this.isEnableFeature;
    }

    const unSelectedFeat = this.appState.getUnSelectedFeatConfig();

    let isConfigEdited = false;
    let featIndex: number = 0;
    if (unSelectedFeat != null) {
      unSelectedFeat.forEach((element) => {
        if (
          element != null &&
          element["featureName"] != null &&
          element["featureName"].toString().toUpperCase() === "AMPDIM"
        ) {
          isConfigEdited = true;
          this.ngModelval["StopDimLevelValue"] = this.StopDimLevelValue =
            element["featureParameters"][0]["StopDimLevel"];
          this.StopDimLevelDisplayValue = element["featureParameters"][0]["StopDimLevel"];
          this.ngModelval["VmainsStopValue"] = this.VmainsStopValue =
            element["featureParameters"][0]["VmainsStop"];
          this.VmainsStopDisplayValue = element["featureParameters"][0]["VmainsStop"];
          this.ngModelval["StartDimLevelValue"] = this.StartDimLevelValue =
            element["featureParameters"][0]["StartDimLevel"];
          this.StartDimLevelDisplayValue = element["featureParameters"][0]["StartDimLevel"];
          this.ngModelval["VmainsStartValue"] = this.VmainsStartValue =
            element["featureParameters"][0]["VmainsStart"];
          this.VmainsStartDisplayValue = element["featureParameters"][0]["VmainsStart"];

          if (this.showAmpDimEnabled && element["featureParameters"][0]["AmpDimEnabled"] != null) {
            const enabledValue = element["featureParameters"][0]["AmpDimEnabled"];
            this.ngModelval["AmpDimEnabledVal"] = this.isEnableFeature = Boolean(enabledValue);
            this.ampDimDisabled = !this.isEnableFeature;
          }

          unSelectedFeat.splice(featIndex, 1);
          this.appState.setUnSelectedFeatConfig(unSelectedFeat);
          this.checkInvalidValues();
          this.checkDefaults();
        } else {
          featIndex++;
        }
      });
    }


    this.service.getquickConfig.subscribe((data) => {
      if (data === "quickConfig") {
        this.quickConfigvalue = true;
        this.quickConfigCustomCSS = "quick-custom-inputbox textBoxUnit";
        this.setQuickConfig = "quickConfig";
      } else if (data === "standard") {
        this.quickConfigvalue = false;
        this.quickConfigCustomCSS = "custom-inputbox";
        this.setQuickConfig = "standard";
      }
      setTimeout(() => {
        if (this.ref && !(this.ref as ViewRef).destroyed) {
          this.ref.detectChanges();
        }
      });
    });
    if (!isConfigEdited) {
      // Use centralized method to get feature data
      // Try different case variations for backward compatibility
      const apmDimData = this.appState.getFeatureData('AmpDim') ||
                         this.appState.getFeatureData('ampdim');

      if (apmDimData) {
        this.addAmpDimLoadedFeatureReadValues(apmDimData);
      }
    }

    this.sendAmpDimdata();

    this.VmainsStopDisplayValue = this.VmainsStopValue;
    this.StopDimLevelDisplayValue = this.StopDimLevelValue;
    this.VmainsStartDisplayValue = this.VmainsStartValue;
    this.StartDimLevelDisplayValue = this.StartDimLevelValue;

    this.vmainsStopInputSubject.pipe(
      debounceTime(50),
      distinctUntilChanged()
    ).subscribe(value => {
      this.validateAndUpdateField(value, 'VmainsStopValue');
    });

    this.stopDimLevelInputSubject.pipe(
      debounceTime(50),
      distinctUntilChanged()
    ).subscribe(value => {
      this.validateAndUpdateField(value, 'StopDimLevelValue');
    });

    this.vmainsStartInputSubject.pipe(
      debounceTime(50),
      distinctUntilChanged()
    ).subscribe(value => {
      this.validateAndUpdateField(value, 'VmainsStartValue');
    });

    this.startDimLevelInputSubject.pipe(
      debounceTime(50),
      distinctUntilChanged()
    ).subscribe(value => {
      this.validateAndUpdateField(value, 'StartDimLevelValue');
    });
  }
  addAmpDimLoadedFeatureReadValues(ampDimLoad: LegacyAny) {
    const ampDimLoadOnj = ampDimLoad;
    const keys = Object.keys(ampDimLoadOnj);
    const values = Object.values(ampDimLoadOnj);
    keys.forEach((key, i) => {
      this.textValChanged(values[i], key + "Value");
    });
    const result = [];
    keys.forEach((key, i) => (result[key] = values[i]));
    this.ngModelval["StopDimLevelValue"] = this.StopDimLevelValue = result[
      "StopDimLevel"
    ]
      ? result["StopDimLevel"]
      : result["StopDimLevelValue"];
    this.StopDimLevelDisplayValue = this.StopDimLevelValue;
    this.ngModelval["VmainsStopValue"] = this.VmainsStopValue = result[
      "VmainsStop"
    ]
      ? result["VmainsStop"]
      : result["VmainsStopValue"];
    this.VmainsStopDisplayValue = this.VmainsStopValue;
    this.ngModelval["StartDimLevelValue"] = this.StartDimLevelValue = result[
      "StartDimLevel"
    ]
      ? result["StartDimLevel"]
      : result["StartDimLevelValue"];
    this.StartDimLevelDisplayValue = this.StartDimLevelValue;
    this.ngModelval["VmainsStartValue"] = this.VmainsStartValue = result[
      "VmainsStart"
    ]
      ? result["VmainsStart"]
      : result["VmainsStartValue"];
    this.VmainsStartDisplayValue = this.VmainsStartValue;
    if (this.showAmpDimEnabled) {
      const enabledVal = result["AmpDimEnabled"] != null ? result["AmpDimEnabled"]
        : result["AmpDimEnabledVal"] != null ? result["AmpDimEnabledVal"] : null;
      if (enabledVal != null) {
        this.ngModelval["AmpDimEnabledVal"] = this.isEnableFeature = Boolean(enabledVal);
        this.ampDimDisabled = !this.isEnableFeature;
      }
    }
    this.checkInvalidValues();
    this.checkDefaults();
  }

  setConfigurationData(value, keyVal) {
    if (value != null) {
      // Use centralized method to save feature data
      // This automatically saves to both ConfigurationData and SaveSetData
      const ampDimObj = Object.assign({}, value);
      this.appState.setFeatureData(keyVal, ampDimObj);
    }
  }


  sendAmpDimdata() {
    this.service.sendAmpDimdata(this.ngModelval);
    this.setConfigurationData(this.ngModelval, "AmpDim");
  }

  enableFeatureChanged(value: boolean) {
    this.ampdimDefaultColor = value;
    this.isEnableFeature = this.ngModelval["AmpDimEnabledVal"] = value;
    this.ampDimDisabled = !value;
    this.checkDefaults();
    this.service.setAmpDimDefaultColor(this.ampdimDefaultColor);
    this.sendAmpDimdata();
  }

  checkDefaults() {
    try {
      this.ampdimDefaultColor = false;
      const enableMatch = this.showAmpDimEnabled
        ? (this.isEnableFeature === (this.properties.AmpDimEnabled?.default ?? false))
        : true;
      if ((this.VmainsStop.default === this.VmainsStopValue)
          && (this.StopDimLevel.default === this.StopDimLevelValue)
          && (this.VmainsStart.default === this.VmainsStartValue)
          && (this.StartDimLevel.default === this.StartDimLevelValue)
          && enableMatch) {
        this.ampdimDefaultColor = true;
      }
      this.service.setAmpDimDefaultColor(this.ampdimDefaultColor);
    } catch {}
  }
  resetDefaultAmpDimValues() {
    try {
      if (this.showAmpDimEnabled) {
        this.ngModelval["AmpDimEnabledVal"] = this.isEnableFeature = this.properties.AmpDimEnabled?.default ?? false;
        this.ampDimDisabled = !this.isEnableFeature;
      }
      this.ngModelval["StopDimLevelValue"] = this.StopDimLevelValue =
        this.StopDimLevel.default;
      this.StopDimLevelDisplayValue = this.StopDimLevel.default;
      this.ngModelval["VmainsStopValue"] = this.VmainsStopValue =
        this.VmainsStop.default;
      this.VmainsStopDisplayValue = this.VmainsStop.default;
      this.ngModelval["StartDimLevelValue"] = this.StartDimLevelValue =
        this.StartDimLevel.default;
      this.StartDimLevelDisplayValue = this.StartDimLevel.default;
      this.ngModelval["VmainsStartValue"] = this.VmainsStartValue =
        this.VmainsStart.default;
      this.VmainsStartDisplayValue = this.VmainsStart.default;
      // this.ngModelval["PhilipsLedLightEnginesSelected"] =
      //   this.PhilipsLedLightEnginesSelected =
      //     this.properties.PhilipsLedLightEnginesSelected.const;
      for (const type in this.inputError) {
        this.inputError[type] = false;
      }
    } catch {}
    setTimeout(() => {
      this.checkDefaults();
      this.ampDimCreateFile = false;
      this.service.ampdimInputError(this.ampDimCreateFile);
      this.sendAmpDimdata();
    }, 1500);
    this.ref.markForCheck();
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }
  checkInvalidValues() {
    this.ampDimCreateFile = false;
    for (const type in this.inputError) {
      if (this.inputError[type]) {
        this.ampDimCreateFile = true;
      }
    }
    this.checkDefaults();
    this.service.ampdimInputError(this.ampDimCreateFile);
  }
  //Low
  VmainsStopValueChange(value) {
    this.inputError["VmainsStopValue"] = false;
    if (value > this.VmainsStartValue) {
      this.ngModelval["VmainsStopValue"] = this.ngModelval["VmainsStartValue"];
      this.VmainsStopValue = this.ngModelval["VmainsStartValue"];
      this.VmainsStopDisplayValue = this.ngModelval["VmainsStartValue"];
    } else if (
      (value >= this.VmainsStopMin || value <= this.VmainsStopMax) &&
      value <= this.VmainsStartValue
    ) {
      this.ngModelval["VmainsStopValue"] = value;
      this.VmainsStopValue = value;
      this.VmainsStopDisplayValue = value;
    }

    if (this.VmainsStop.default != this.VmainsStopValue) {
      this.service.setAmpDimDefaultColor(false);
    }
    this.checkInvalidValues();
    this.sendAmpDimdata();
    this.ref.detectChanges(); // Trigger change detection
  }
  //Low V %
  StopDimLevelValueChange(value) {
    this.inputError["StopDimLevelValue"] = false;

    if (value > this.StartDimLevelValue) {
      this.ngModelval["StopDimLevelValue"] =
        this.ngModelval["StartDimLevelValue"];
      this.StopDimLevelValue = this.ngModelval["StartDimLevelValue"];
      this.StopDimLevelDisplayValue = this.ngModelval["StartDimLevelValue"];
    } else if (
      (value >= this.StopDimLevelMin || value <= this.StopDimLevelMax) &&
      value <= this.StartDimLevelValue
    ) {
      this.ngModelval["StopDimLevelValue"] = value;
      this.StopDimLevelValue = value;
      this.StopDimLevelDisplayValue = value;
    }

    if (this.StopDimLevel.default != this.StopDimLevelValue) {
      this.service.setAmpDimDefaultColor(false);
    }
    this.checkInvalidValues();
    this.sendAmpDimdata();
    this.ref.detectChanges();
  }

  //High
  VmainsStartValueChange(value) {
    this.inputError["VmainsStartValue"] = false;
    this.ngModelval["VmainsStartValue"] = value;
    this.VmainsStartValue = value;
    this.VmainsStartDisplayValue = value;

    if (value >= this.VmainsStartMin || value <= this.VmainsStartMax) {
      this.ngModelval["VmainsStartValue"] = value;
      this.VmainsStartValue = value;
      this.VmainsStartDisplayValue = value;
    }
    if (this.VmainsStopValue > this.VmainsStartValue) {
      this.ngModelval["VmainsStopValue"] = value;
      this.VmainsStopValue = value;
      this.VmainsStopDisplayValue = value;
    }

    if (this.VmainsStart.default != this.VmainsStartValue) {
      this.service.setAmpDimDefaultColor(false);
    }
    this.checkInvalidValues();
    this.sendAmpDimdata();
    this.ref.detectChanges();
  }
  //High %
  StartDimLevelValueChange(value) {
    this.inputError["StartDimLevelValue"] = false;
    if (value >= this.StartDimLevelMin || value <= this.StartDimLevelMax) {
      this.ngModelval["StartDimLevelValue"] = value;
      this.StartDimLevelValue = value;
      this.StartDimLevelDisplayValue = value; // Sync display
    }
    if (this.StopDimLevelValue > this.StartDimLevelValue) {
      this.ngModelval["StopDimLevelValue"] = value;
      this.StopDimLevelValue = value;
      this.StopDimLevelDisplayValue = value; // Sync display
    }

    if (this.StartDimLevel.default != this.StartDimLevelValue) {
      this.service.setAmpDimDefaultColor(false);
    }
    this.checkInvalidValues();
    this.sendAmpDimdata();
    this.ref.detectChanges(); // Trigger change detection
  }

  onFieldInput(value: string, fieldName: string) {
    if (fieldName === 'VmainsStopValue') {
      this.VmainsStopDisplayValue = value;
      this.vmainsStopInputSubject.next(value);
    } else if (fieldName === 'StopDimLevelValue') {
      this.StopDimLevelDisplayValue = value;
      this.stopDimLevelInputSubject.next(value);
    } else if (fieldName === 'VmainsStartValue') {
      this.VmainsStartDisplayValue = value;
      this.vmainsStartInputSubject.next(value);
    } else if (fieldName === 'StartDimLevelValue') {
      this.StartDimLevelDisplayValue = value;
      this.startDimLevelInputSubject.next(value);
    }
    this.ref.detectChanges();
  }
  onFieldBlur(fieldName: string) {
    let value: string;
    if (fieldName === 'VmainsStopValue') {
      value = this.VmainsStopDisplayValue;
    } else if (fieldName === 'StopDimLevelValue') {
      value = this.StopDimLevelDisplayValue;
    } else if (fieldName === 'VmainsStartValue') {
      value = this.VmainsStartDisplayValue;
    } else if (fieldName === 'StartDimLevelValue') {
      value = this.StartDimLevelDisplayValue;
    }
    this.validateAndUpdateField(value, fieldName);
  }
  validateAndUpdateField(value: string, colName: string) {
    let numValue = parseFloat(value);

    if (isNaN(numValue) || value === '' || value === null || value === undefined) {
      this.inputError[colName] = true;
      this.ampDimCreateFile = true;

      if (colName === 'VmainsStopValue') {
        this.VmainsStopDisplayValue = value;
        this.ngModelval['VmainsStopValue'] = this.VmainsStopMin;
        this.VmainsStopValue = this.VmainsStopMin;
      } else if (colName === 'StopDimLevelValue') {
        this.StopDimLevelDisplayValue = value;
        this.ngModelval['StopDimLevelValue'] = this.StopDimLevelMin;
        this.StopDimLevelValue = this.StopDimLevelMin;
      } else if (colName === 'VmainsStartValue') {
        this.VmainsStartDisplayValue = value;
        this.ngModelval['VmainsStartValue'] = this.VmainsStartMin;
        this.VmainsStartValue = this.VmainsStartMin;
      } else if (colName === 'StartDimLevelValue') {
        this.StartDimLevelDisplayValue = value;
        this.ngModelval['StartDimLevelValue'] = this.StartDimLevelMin;
        this.StartDimLevelValue = this.StartDimLevelMin;
      }

      this.service.ampdimInputError(this.ampDimCreateFile);
      this.service.setAmpDimDefaultColor(false);
      this.ref.detectChanges();
      return;
    }

    numValue = parseInt(value);
    this.ampdimDefaultColor = false;
    this.inputError[colName] = false;
    this.ampDimCreateFile = false;

    if (colName === 'VmainsStopValue') {
      if (numValue < this.VmainsStopMin || numValue > this.VmainsStopMax || numValue > this.VmainsStartValue) {
        this.inputError[colName] = true;
        this.VmainsStopDisplayValue = value;
        this.service.setAmpDimDefaultColor(false);

        let clampedValue;
        if (numValue < this.VmainsStopMin) {
          clampedValue = this.VmainsStopMin;
        } else if (numValue > this.VmainsStopMax) {
          clampedValue = this.VmainsStopMax;
        } else if (numValue > this.VmainsStartValue) {
          clampedValue = this.VmainsStartValue;
        }
        this.ngModelval['VmainsStopValue'] = clampedValue;
        this.VmainsStopValue = clampedValue;
      } else {
        this.ngModelval['VmainsStopValue'] = numValue;
        this.VmainsStopValue = numValue;
        this.VmainsStopDisplayValue = numValue;
        this.inputError[colName] = false;
      }
      if (this.VmainsStop.default != this.VmainsStopValue) {
        this.service.setAmpDimDefaultColor(false);
      }
    } else if (colName === 'StopDimLevelValue') {
      if (numValue < this.StopDimLevelMin || numValue > this.StopDimLevelMax || numValue > this.StartDimLevelValue) {
        this.inputError[colName] = true;
        this.StopDimLevelDisplayValue = value;
        this.service.setAmpDimDefaultColor(false);
        let clampedValue;
        if (numValue < this.StopDimLevelMin) {
          clampedValue = this.StopDimLevelMin;
        } else if (numValue > this.StopDimLevelMax) {
          clampedValue = this.StopDimLevelMax;
        } else if (numValue > this.StartDimLevelValue) {
          clampedValue = this.StartDimLevelValue;
        }
        this.ngModelval['StopDimLevelValue'] = clampedValue;
        this.StopDimLevelValue = clampedValue;
      } else {
        this.ngModelval['StopDimLevelValue'] = numValue;
        this.StopDimLevelValue = numValue;
        this.StopDimLevelDisplayValue = numValue;
        this.inputError[colName] = false;
      }
      if (this.StopDimLevel.default != this.StopDimLevelValue) {
        this.service.setAmpDimDefaultColor(false);
      }
    } else if (colName === 'VmainsStartValue') {
      if (numValue < this.VmainsStartMin || numValue > this.VmainsStartMax) {
        this.inputError[colName] = true;
        this.VmainsStartDisplayValue = value;
        this.service.setAmpDimDefaultColor(false);

        let clampedValue;
        if (numValue < this.VmainsStartMin) {
          clampedValue = this.VmainsStartMin;
        } else if (numValue > this.VmainsStartMax) {
          clampedValue = this.VmainsStartMax;
        }
        this.ngModelval['VmainsStartValue'] = clampedValue;
        this.VmainsStartValue = clampedValue;

        if (this.ngModelval['VmainsStopValue'] < this.VmainsStopMin || this.ngModelval['VmainsStopValue'] > this.VmainsStopMax) {
          this.inputError['VmainsStopValue'] = true;
        }
      } else {
        this.ngModelval['VmainsStartValue'] = numValue;
        this.VmainsStartValue = numValue;
        this.VmainsStartDisplayValue = numValue;
        this.inputError[colName] = false;

        if (numValue < this.VmainsStopValue) {
          this.ngModelval['VmainsStopValue'] = numValue;
          this.VmainsStopValue = numValue;
          this.VmainsStopDisplayValue = numValue;
        }

        if (this.ngModelval['VmainsStopValue'] < this.VmainsStopMin || this.ngModelval['VmainsStopValue'] > this.VmainsStopMax) {
          this.inputError['VmainsStopValue'] = true;
        } else {
          this.inputError['VmainsStopValue'] = false;
        }
      }
      if (this.VmainsStart.default != this.VmainsStartValue) {
        this.service.setAmpDimDefaultColor(false);
      }
    } else if (colName === 'StartDimLevelValue') {
      if (numValue < this.StartDimLevelMin || numValue > this.StartDimLevelMax) {
        this.inputError[colName] = true;
        this.StartDimLevelDisplayValue = value;
        this.service.setAmpDimDefaultColor(false);
        let clampedValue;
        if (numValue < this.StartDimLevelMin) {
          clampedValue = this.StartDimLevelMin;
        } else if (numValue > this.StartDimLevelMax) {
          clampedValue = this.StartDimLevelMax;
        }
        this.ngModelval['StartDimLevelValue'] = clampedValue;
        this.StartDimLevelValue = clampedValue;

        if (this.ngModelval['StopDimLevelValue'] < this.StopDimLevelMin || this.ngModelval['StopDimLevelValue'] > this.StopDimLevelMax) {
          this.inputError['StopDimLevelValue'] = true;
        }
      } else {
        this.ngModelval['StartDimLevelValue'] = numValue;
        this.StartDimLevelValue = numValue;
        this.StartDimLevelDisplayValue = numValue;
        this.inputError[colName] = false;

        if (numValue < this.StopDimLevelValue) {
          this.ngModelval['StopDimLevelValue'] = numValue;
          this.StopDimLevelValue = numValue;
          this.StopDimLevelDisplayValue = numValue;
          this.inputError['StopDimLevelValue'] = false;
        } else {
          this.inputError['StopDimLevelValue'] = false;
        }
      }
      if (this.StartDimLevel.default != this.StartDimLevelValue) {
        this.service.setAmpDimDefaultColor(false);
      }
    }

    this.checkInvalidValues();
    this.sendAmpDimdata();
    this.ref.detectChanges();
  }

  textValChanged(value, colName) {
    value = parseInt(value);
    if (isNaN(value) || value.length === 0) {
      value = 0;
    }
    this.ampdimDefaultColor = false;
    this.inputError[colName] = false;
    this.ampDimCreateFile = false;
    if (colName == "VmainsStopValue") {
      this.inputError[colName] = false;
      if (value < this.VmainsStopMin || value > this.VmainsStopMax) {
        this.inputError[colName] = true;
        this.service.setAmpDimDefaultColor(false);
        this.ngModelval["VmainsStopValue"] = value;
      } else {
        if (value > this.VmainsStartValue) {
          this.inputError[colName] = true;
          this.ngModelval["VmainsStopValue"] = value;
        } else {
          this.ngModelval["VmainsStopValue"] = value;
          this.VmainsStopValue = value;
          this.inputError[colName] = false;
        }
      }
      if (this.VmainsStop.default != this.VmainsStopValue) {
        this.service.setAmpDimDefaultColor(false);
      }
    } else if (colName == "StopDimLevelValue") {
      this.inputError[colName] = false;
      if (value < this.StopDimLevelMin || value > this.StopDimLevelMax) {
        this.inputError[colName] = true;
        this.service.setAmpDimDefaultColor(false);
        this.ngModelval["StopDimLevelValue"] = value;
      } else {
        if (value > this.StartDimLevelValue) {
          this.inputError[colName] = true;
          this.ngModelval["StopDimLevelValue"] = value;
        } else {
          this.ngModelval["StopDimLevelValue"] = value;
          this.StopDimLevelValue = value;
          this.inputError[colName] = false;
        }
      }
      if (this.StopDimLevel.default != this.StopDimLevelValue) {
        this.service.setAmpDimDefaultColor(false);
      }
      this.StopDimLevelValue = value;
    } else if (colName == "VmainsStartValue") {
      this.inputError[colName] = false;
      if (value < this.VmainsStartMin || value > this.VmainsStartMax) {
        this.inputError[colName] = true;
        this.service.setAmpDimDefaultColor(false);
        this.ngModelval["VmainsStartValue"] = value;
        // this.ngModelval["VmainsStopValue"] = value;
        // this.VmainsStopValue = value;
        if (
          this.ngModelval["VmainsStopValue"] < this.VmainsStopMin ||
          this.ngModelval["VmainsStopValue"] > this.VmainsStopMax
        ) {
          this.inputError["VmainsStopValue"] = true;
        }
      } else {
        if (value < this.VmainsStopValue) {
          this.ngModelval["VmainsStopValue"] = value;
          this.VmainsStopValue = value;
          this.ngModelval["VmainsStartValue"] = value;
          this.VmainsStartValue = value;
        } else {
          this.ngModelval["VmainsStartValue"] = value;
          this.VmainsStartValue = value;
          this.inputError[colName] = false;
          // this.ngModelval["VmainsStopValue"] = value;
          // this.VmainsStopValue = value;
          if (
            this.ngModelval["VmainsStopValue"] < this.VmainsStopMin ||
            this.ngModelval["VmainsStopValue"] > this.VmainsStopMax
          ) {
            this.inputError["VmainsStopValue"] = true;
          } else {
            this.inputError["VmainsStopValue"] = false;
          }
        }
      }
      if (this.VmainsStart.default != this.VmainsStartValue) {
        this.service.setAmpDimDefaultColor(false);
      }
    } else if (colName == "StartDimLevelValue") {
      this.inputError[colName] = false;
      if (value < this.StartDimLevelMin || value > this.StartDimLevelMax) {
        this.inputError[colName] = true;
        this.service.setAmpDimDefaultColor(false);
        this.ngModelval["StartDimLevelValue"] = value;
        // this.ngModelval["StopDimLevelValue"] = value;
        // this.StopDimLevelValue = value;
        if (
          this.ngModelval["StopDimLevelValue"] < this.StopDimLevelMin ||
          this.ngModelval["StopDimLevelValue"] > this.StopDimLevelMax
        ) {
          this.inputError["StopDimLevelValue"] = true;
        }
      } else {
        if (value < this.StopDimLevelValue) {
          this.ngModelval["StopDimLevelValue"] = value;
          this.StopDimLevelValue = value;
          this.ngModelval["StartDimLevelValue"] = value;
          this.StartDimLevelValue = value;
          this.inputError["StopDimLevelValue"] = false;
        } else {
          this.ngModelval["StartDimLevelValue"] = value;
          this.StartDimLevelValue = value;
          this.inputError[colName] = false;
          // this.ngModelval["StopDimLevelValue"] = value;
          // this.StopDimLevelValue = value;
          this.inputError["StopDimLevelValue"] = false;
        }
      }
      if (this.StartDimLevel.default != this.StartDimLevelValue) {
        this.service.setAmpDimDefaultColor(false);
      }
    }
    this.checkInvalidValues();
    this.sendAmpDimdata();
  }

  ngOnDestroy() {}
}
